module.exports = __webpack_public_path__ + "media/features/feature-slide1-90bde8d7.png";